export default __webpack_public_path__ + "static/media/arrow_back-24px.037e7aeb.svg";